import { connect } from 'react-redux'
import { setCurrentOrganization } from '../state/actions/organizations/index'
import { actionCreators } from '../state/actions/trips/index'
import { IStoreState } from '../types/state'
import { LOCAL_STORAGE_CURRENT_ORGANIZATION_KEY } from '../types'
import App from '../components/App'
import { setCurrentUserToStore } from '../state/actions/users'
import { IAuthJwtPayloadDTO } from '../types/user'

const mapStateToProps = (state: IStoreState) => {
  // If the organization name is found (from the search query), return the organization id from the list of items
  // Other return null
  const organization =
    state.organizations.currentOrgId && state.organizations.currentOrgIdRequest
      ? state.organizations.items[state.organizations.currentOrgId]
      : null

  if (organization !== null) {
    // organization has a value, display the filtered results
    return {
      organization,
      currentOrgId: state.organizations.currentOrgId,
      auth: state.authorization
    }
  } else {
    // organization has no value, display none
    return {
      organization: undefined,
      currentOrgId: state.organizations.currentOrgId,
      auth: state.authorization
    }
  }
}

const mapDispatchToProps = (dispatch: any) => {
  return {
    setCurrentOrg: (organizationId: string) => {
      // Save current organization id to redux's store
      if (organizationId) {
        if (!localStorage.getItem(LOCAL_STORAGE_CURRENT_ORGANIZATION_KEY)) {
          localStorage.setItem(LOCAL_STORAGE_CURRENT_ORGANIZATION_KEY, organizationId)
        }
        const orgId = localStorage.getItem(LOCAL_STORAGE_CURRENT_ORGANIZATION_KEY) || organizationId
        dispatch(setCurrentOrganization(orgId))
        dispatch(actionCreators.updateTripFilters({ orgId }))
      }
    },
    setCurrentUserToStore: (accessJwtPayload: IAuthJwtPayloadDTO) => dispatch(setCurrentUserToStore(accessJwtPayload))
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(App)



// WEBPACK FOOTER //
// ./src/containers/App.ts